import React from 'react';
import Contact from '../components/pages/Contact';

const ContactPage = (props) => {
    
    return <Contact />;
};

export default ContactPage;